module.exports = __webpack_public_path__ + "static/media/IMG_2893 - Version 3.8040e83e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/items/IMG_2893 - Version 3.jpg
// module id = 525
// module chunks = 0